import React from 'react';
import { Card, CardBody } from 'reactstrap';
import PaymentForm from '../../../Sales/SalesPoint/components/PaymentForm';

/**
 * Painel de Seleção para Quitação de Saldo.
 * Exibe apenas a aba de Pagamento.
 */
const DebtSelectionPanel = ({
    acquirers,
    suggestedValue,
    onAddPayment,
    saleDate,
    setSaleDate
}) => {
    return (
        <Card className="shadow-sm border-0 h-100">
            <CardBody className="d-flex flex-column h-100 p-0">
                <div className="p-4 pt-5 pb-3 flex-grow-1">
                    <PaymentForm
                        acquirers={acquirers}
                        suggestedValue={suggestedValue}
                        onAddPayment={onAddPayment}
                    />
                </div>
            </CardBody>
        </Card>
    );
};

export default DebtSelectionPanel;
